var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-min-space"},[_c('b-form-group',{class:{
            'required-field': _vm.requiredFields,
        },attrs:{"label":_vm.field.label,"label-for":`id_${_vm.field._id}`}},[_c('div',{staticClass:"row profile-setup"},[_c('div',{staticClass:"col-md-5 mb-20 dialling-code-field"},[_c('isd-code',{directives:[{name:"validate",rawName:"v-validate",value:({
                        required: _vm.requiredFields,
                    }),expression:"{\n                        required: requiredFields,\n                    }"}],class:{
                        'is-invalid': _vm.errors.has('Dialing Code'),
                    },attrs:{"data-segment-id":_vm.dataSegmentId,"field":{
                        association: 'countries',
                        isAssociation: true,
                        type: 'isd-code',
                        isLocked: true,
                        isRequired: _vm.requiredFields,
                        label: 'Dialing code',
                        placeholder: 'Dialing code',
                        options: [],
                        key: _vm.isdKey,
                        customerDetails: this.field.customerDetails?this.field.customerDetails:null,
                        disabled:_vm.isDisabled
                    },"text-field":"isdCodeTitle","value-field":"isdCode","multiple":false,"name":"Dialing Code"}})],1),_c('div',{staticClass:"col-md-7"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({
                        required: _vm.requiredFields,
                        min: 8,
                        regex: /^([0-9]*)$/,
                    }),expression:"{\n                        required: requiredFields,\n                        min: 8,\n                        regex: /^([0-9]*)$/,\n                    }"}],class:{
                        'is-invalid': _vm.errors.has('phone number'),
                    },attrs:{"type":"tel","max-length":"10","placeholder":"Enter phone number","data-vv-name":"phone number","readonly":_vm.readOnly,"disabled":_vm.isDisabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }